module.exports = __webpack_public_path__ + "img/ava_man.460bec94.png";